import React from 'react'

const General = () => {
    return(
        null
    )
}

export default General